/**
 * Created by daniel.merkle on 04.01.2017.
 */
(function($){

    $(document).ready(function() {
        setTimeout(notes, 0);
    });

    function gotonote(){
        var theUrl = window.location.href;
        var hashvalue = theUrl.split('#')[1];

        if(hashvalue){

            function getOffset(){
                hashvalue = "#" + hashvalue;

                $(hashvalue).show();
                scrollToPos = $(hashvalue).offset().top;
                $('body').animate({scrollTop: scrollToPos - 90}, 500, "easeInExpo");

                $(hashvalue).nextAll(".doc-section div.ac:first").delay(750).slideToggle(500, "easeInExpo");
                $(hashvalue).next(".doc-section .ns-title-h1-with-lead").toggleClass('closed');
                $(hashvalue).next(".doc-section .ns-title-h1-with-lead").toggleClass('open');
            }
            setTimeout(getOffset, 0 )
        }
    }

    function notes(){
        if ($("#primary").hasClass("notes-group")){
            var first = true;
            $(".notes-group .ns-title-h1-with-lead:not(.notes-preface)").each(function() {
                $(this).toggleClass('closed');
                if(first){
                    $(this).addClass('first');
                    first = false;
                }
            });

            $(this).slideToggle(500, function(){
                $(this).trigger('notesToggleDone');
            });

            gotonote();
        }

        $('.ns-title-h1-with-lead:not(.notes-preface)').click(function(){
            $(this).next("div.ac").slideToggle(500);
            $(this).toggleClass('closed');
            $(this).toggleClass('open');
        });

        $('tr.head .notes a').each(function () {
            $(this).parent().html( $(this).html() );
        });

        $('tr .notes a').each(function () {
            if($(this).html() == '&nbsp;'){
                $(this).parent().css('visibility', 'hidden');
            }
        });
    }
})(jQuery);
